import { Link } from "react-router-dom";
import Reveal from "@/components/feature/Reveal";

/**
 * 再生医療親ページ内の「幹細胞培養上清液について」説明セクション。
 * 独立ページにはせず、親ページ内のアンカー（#culture-supernatant）から遷移する。
 * 幹細胞そのものを用いる治療であるかのような断定・効果表現は使用しない。
 */
const paragraphs = [
  "幹細胞培養上清液は、幹細胞を培養する過程で得られる培養液の上澄み部分です。",
  "幹細胞そのものを使用する治療ではなく、培養の過程で得られる上清液を用います。",
  "SBDCでは、このStemSupを点滴で投与するメニューとして、StemSup点滴をご案内しています。",
];

export default function RegenerativeCultureSection() {
  return (
    <section id="culture-supernatant" className="bg-background-200 py-16 md:py-20 lg:py-24">
      <div className="u-container">
        <Reveal>
          <div className="flex flex-col gap-5 md:max-w-2xl">
            <span className="en-eyebrow text-[10px] text-secondary-700 md:text-[11px]">CULTURE SUPERNATANT</span>
            <span className="block h-px w-10 bg-accent-500" />
            <h2 className="font-heading text-[24px] leading-[1.55] tracking-[0.01em] text-foreground-950 md:text-[32px]">
              幹細胞培養上清液について
            </h2>
          </div>
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-10 max-w-3xl md:mt-14">
            <div className="space-y-6 border-l-2 border-accent-500/60 pl-5 md:pl-6">
              {paragraphs.map((paragraph) => (
                <p key={paragraph} className="text-[14px] leading-[2.1] text-foreground-700 md:text-[15px]">
                  {paragraph}
                </p>
              ))}
            </div>

            <div className="mt-9">
              <Link
                to="/regenerative/stemsup-drip"
                className="group inline-flex items-center gap-2.5 whitespace-nowrap rounded-md border border-foreground-950/25 px-6 py-3 text-[12.5px] text-foreground-900 transition-colors hover:border-accent-500 hover:bg-background-50"
              >
                StemSup点滴について詳しく見る
                <i
                  className="ri-arrow-right-line text-[14px] text-foreground-500 transition-transform group-hover:translate-x-0.5 group-hover:text-accent-700"
                  aria-hidden
                />
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}